$bog_ui_empty $mol_view
	sub /
		<= Icon $mol_icon_magnify
		<= Title $mol_view
			sub /
				<= title \Nothing found
		<= Message $mol_view
			sub /
				<= message \Try adjusting your search or filters
		<= Action null
